import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { AdminWiseClients } from "../../api/request/license";
import SkeletonTable from "../../components/table/SkeletonTable";
import clientListColumns from "../../columns/License/clientListColumns";
import UserAvatar from "../../components/common/UserAvatar";
import moment from "moment";
import Search from "../../components/common/Search";
import BackButton from "../../components/button/BackButton";

const AdminWiseClientList =() => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [isLoadingLicense, setIsLoadingLicense] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const location = useLocation();
  const adminData = location.state?.adminData;

  const fetchData = async (searchText = "") => {
    try {
      setIsLoadingLicense(true);
      const { data } = await AdminWiseClients({
        id: id,
        type: "client",
        search: searchText,
        page: currentPage,
      });
      setData(
        data?.data?.map((item) => ({
          ...item,
          status: (
            <p
              className={`${
                item?.status == "active" ? "text-green-500" : "text-red-500"
              } capitalize font-bold`}
            >
              {item?.status}
            </p>
          ),
          name: <UserAvatar data={item} />,
          created_at: item?.created_at
            ? moment(item?.created_at).format("lll")
            : "--",
        }))
      );
      setTotal(data?.total_record);
    } catch (error) {
      console.error("Error fetching client list:", error);
    } finally {
      setIsLoadingLicense(false);
    }
  };
  const handleTableChange = (pagination) => {
    setCurrentPage(pagination?.current);
  };

  useEffect(() => {
    if (id) fetchData();
  }, [id]);

  return (
    <>
      {adminData && (
        <div className="p-4 mb-4 rounded-lg  bg-white border ">
          <div className="text-lg font-semibold mb-2">
            <h2 className="font-semibold text-xl mb-3">Admin Details : </h2>
          </div>
          <div className="mr-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-1">
            <div>
              <span className="font-bold">Name: </span>
              {adminData.name || "--"}
            </div>
            <div>
              <span className="font-bold">Email: </span>
              {adminData.email || "--"}
            </div>
            <div>
              <span className="font-bold">Mobile No: </span>
              {adminData.mobile_no || "--"}
            </div>
            <div>
              <span className="font-bold">License Name: </span>
              {adminData.license?.license_name || "--"}
            </div>
          </div>
        </div>
      )}

      <div className="border bg-white rounded-xl py-3">
        <div className="flex items-center justify-between sm:px-4 max-sm:px-2 mb-5">
          <div className="flex items-center gap-2">
            <BackButton />
            <h2 className="font-semibold text-xl">Client List</h2>
          </div>
          <Search handleSearch={fetchData} />
        </div>
        <SkeletonTable
          columns={clientListColumns}
          data={data}
          isLoading={isLoadingLicense}
          pagination={{
            current: currentPage,
            total: total,
            pageSize: 10,
            showSizeChanger: false,
          }}
          handleTableChange={handleTableChange}
        />
      </div>
    </>
  );
}

export default AdminWiseClientList;
